import {BenyttetAutentiseringsmetode, CriiptoIdTilbyder} from "../tjenester/ressurser/generertNg2HttpKlient";

export function benyttetAutentiseringsmetodeFraCriiptoIdTilbyder(tilbyder: CriiptoIdTilbyder): BenyttetAutentiseringsmetode {
    switch (tilbyder) {
        case CriiptoIdTilbyder.norsk_bankid_web_og_mobil:
            return BenyttetAutentiseringsmetode.bankidNorsk;
        case CriiptoIdTilbyder.svensk_bankid_samedevice:
        case CriiptoIdTilbyder.svensk_bankid_anotherdevice:
        case CriiptoIdTilbyder.svensk_bankid_anotherdeviceqr:
            return BenyttetAutentiseringsmetode.bankidSvensk;
    }
}

export function criiptoIdTilbyderFraBenyttetAutentiseringsmetode(metode: BenyttetAutentiseringsmetode): CriiptoIdTilbyder[] {
    switch (metode) {
        case BenyttetAutentiseringsmetode.bankidNorsk:
            return [CriiptoIdTilbyder.norsk_bankid_web_og_mobil];
        case BenyttetAutentiseringsmetode.bankidSvensk:
            return [CriiptoIdTilbyder.svensk_bankid_samedevice, CriiptoIdTilbyder.svensk_bankid_anotherdevice, CriiptoIdTilbyder.svensk_bankid_anotherdeviceqr];
        default:
            return [];
    }
}
